<template>
  <v-hover>
    <v-card
      slot-scope="{hover}"
      flat
      class="clickable"
    >
      <v-card-text
        class="px-2"
        @click="$emit('click')"
      >
        <v-layout
          :column="$vuetify.breakpoint.xs"
          align-center
        >
          <div
            v-if="icon"
            class="info-icon"
            :class="{'ml-4 mr-3': $vuetify.breakpoint.smAndUp}"
          >
            <v-badge
              :class="{smaller: number > 99}"
              left
              overlap
            >
              <span
                v-if="numberUnseen"
                slot="badge"
                class="font-weight-bold"
              >{{
                numberUnseen
              }}</span>
              <v-icon
                v-if="icon"
                x-large
                :class="{'msr--text': hover, 'grey--text': !hover}"
                v-html="icon"
              />
            </v-badge>
          </div>
          <div
            v-else
            class="ml-3"
          />
          <div
            class="info-text"
            :class="{
              'mt-2': $vuetify.breakpoint.xs,
              'msr--text': hover,
              'grey--text': !hover,
            }"
          >
            <v-layout align-center>
              <span
                v-if="visitorcountDemoMode"
                style="max-height: 42px"
              >
                <v-badge
                  color="transparent msr--text"
                  class="smaller"
                >
                  <span
                    v-if="$store.state.common.showBetaFeatureMarkers"
                    slot="badge"
                    class="highlighted-badge-text"
                  >
                    Demo
                  </span>
                  <v-icon
                    :class="[hover ? 'msr--text' : 'grey--text']"
                    x-large
                  >timeline</v-icon>
                </v-badge></span>
              <span v-else>{{ number }}</span>
            </v-layout>
            <div class="detail">
              {{ subtitle }}
            </div>
          </div>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-hover>
</template>

<script>
export default {
  props: {
    number: {
      type: Number,
      required: true,
    },
    numberUnseen: {
      type: Number,
      default: null,
    },
    subtitle: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    visitorcountDemoMode: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.info-text {
  color: rgba(0, 0, 0, 0.3);
  font-weight: bold;
  font-size: 2em;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.info-text .detail {
  font-size: 0.5em;
  margin-top: -0.3em;
}

.info-icon {
  max-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/DashboardIndicatorCard.vue